export default __webpack_public_path__ + "static/media/promo_code.062e79d6.svg";